export const sourceSchema = {
  type: "object",
  properties: {
    surveyID: {
      type: "string",
    },
    IsPartialSaveEnabled: {
      type: "boolean",
    },
    IsRuleBasedSurvey: {
      type: "boolean",
    },

    LastUpdatedPageNumber: {
      type: "integer",
    },

    surveyCode: {
      type: ["string", "null"],
    },
    surveyPages: {
      type: "array",
      items: {
        type: "object",
        properties: {
          pageNumber: {
            type: "integer",
          },
          checkForSurveyCompletion: {
            type: "boolean",
          },
          isPageValidationEnabled: {
            type: "boolean",
          },
          // SurveyCompletionCheckCondition: {
          //   type: "string",
          // },
          surveyQuestions: {
            type: "array",
            items: {
              questionCode: {
                type: "string",
              },
              Response: {
                type: "string",
              },
              ResponseCode: {
                type: ["integer", "null"],
              },
              FieldDelimiter: {
                type: "string",
              },
              OtherResponse: {
                type: ["string", "null"],
              },
              PatientActivityDetailID: {
                type: "string",
              },
              questionText: {
                type: "string",
              },
              questionType: {
                type: "integer",
              },
              textDataType: {
                type: "integer",
              },
              surveyQuestionChoices: {
                type: "array",
                items: {
                  choiceCode: {
                    type: "string",
                  },
                  choiceText: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
export const parsedSchema = {};
export const expression_parseFromSource =
  "{ " +
  '"activityId":surveyID,' +
  '"activityName":surveyCode, ' +
  '"activityStatus":120000000, ' +
  '"activityType":120000006, ' +
  '"isPartialSaveEnabled": IsPartialSaveEnabled,' +
  '"IsRuleBasedSurvey": IsRuleBasedSurvey,' +
  '"lastUpdatedPageNumber": LastUpdatedPageNumber,' +
  '"member":{ ' +
  '"id":"", ' +
  '"formatedValue": "", ' +
  '"entity": "" ' +
  " }," +
  ' "pages" : [surveyPages.{' +
  '"pageNumber":pageNumber,' +
  '"isPageValidationEnabled":isPageValidationEnabled,' +
  '"checkForSurveyCompletion": checkForSurveyCompletion? true:false,' +
  '"SurveyCompletionCheckCondition": (checkForSurveyCompletion) ? {' +
  '"conditionType": 120000000,' +
  '"conditionOperator": 120000001,' +
  '"compareOperator": 0,' +
  '"fieldCondition": null,' +
  '"filterConditions": (' +
  "SurveyCompletionCheckCondition.filterConditions[].{" +
  '"conditionType": conditionType,' +
  '"conditionOperator": conditionOperator,' +
  '"compareOperator": compareOperator,' +
  '"fieldCondition": fieldCondition ? {' +
  '"questionCode": fieldCondition.questionCode,' +
  '"answerCode": fieldCondition.answerCode' +
  " } : null," +
  '"filterConditions": filterConditions ? (' +
  "filterConditions[].{" +
  ' "conditionType": conditionType,' +
  '"conditionOperator": conditionOperator,' +
  '"compareOperator": compareOperator,' +
  '"fieldCondition": fieldCondition ? {' +
  '"questionCode": fieldCondition.questionCode,' +
  '"answerCode": fieldCondition.answerCode' +
  "} : null," +
  '"filterConditions": null,' +
  '"conditionOutput": conditionOutput' +
  "}" +
  ") : null," +
  '"conditionOutput": conditionOutput' +
  "}" +
  ")," +
  '"conditionOutput": conditionOutput' +
  "} : null," +
  '"saveOnNav":false,' +
  '"questionGroups":[{' +
  '"questionGroupId": "g1", ' +
  '"questionGroup": "Qus Group", ' +
  '"questionSection": "Qus Sec", ' +
  '"questionSubSection": "Qus SubSection" , ' +
  '"questions":[surveyQuestions.{' +
  '"id": questionCode,' +
  '"PatientActivityDetailID": PatientActivityDetailID,' +
  '"questionNumber": questionCode,' +
  '"questionCode": questionCode,' +
  '"questionText": questionText,' +
  '"responseType": questionType,' +
  '"questionType": questionType,' +
  '"responseDataType": textDataType,' +
  '"response": Response ? Response : null,' +
  '"responseCode": ResponseCode,' +
  '"QuestionTextCode": QuestionTextCode,' +
  '"ChoicesTextCode": ChoicesTextCode,' +
  '"answerCodes": null,' +
  '"fielddelimiter": FieldDelimiter,' +
  '"choices": [surveyQuestionChoices.' +
  " {" +
  '"choiceCode": choiceCode,' +
  '"choiceText": choiceText,' +
  '"choiceTextInDefaultLanguage": choiceTextInDefaultLanguage,' +
  '"scoringValue": scoringValue,' +
  '"choiceOrder": choiceOrder' +
  "  }]," +
  '"completionStatus": 120000000,' +
  '"hasOthers": IsOtherEnabled,' +
  '"othersResponse": OthersResponse,' +
  '"hasNOA": IsNoneOfTheAboveEnabled,' +
  '"noaText": NoneOfTheAboveText,' +
  '"isRequired": IsMandatory,' +
  '"validationSetting": ValidationSetting,' +
  '"AdditionalSetting": AdditionalSetting,' +
  '"sectionName":SectionName,' +
  '"subSectionName":SubSectionName,' +
  '"isVisible": false,' +
  '"hasVisibilityRule": isVisibleConditionEnabled? true:false,' +
  '"visibilityRule":(isVisibleConditionEnabled) ? {' +
  '"conditionType": visibleCondition.conditionType,' +
  '"conditionOperator": visibleCondition.conditionOperator,' +
  '"compareOperator": visibleCondition.compareOperator,' +
  '"fieldCondition":  null,' +
  '"filterConditions": visibleCondition.filterConditions ? (' +
  "visibleCondition.filterConditions[].{" +
  '"conditionType": conditionType,' +
  '"conditionOperator": conditionOperator,' +
  '"compareOperator": compareOperator,' +
  '"fieldCondition": fieldCondition ? {' +
  '"questionNumber": fieldCondition.questionCode,' +
  '"answerCode": fieldCondition.answerCode' +
  "} : null," +
  '"filterConditions": null,' +
  '"conditionOutput": conditionOutput' +
  "}" +
  ") : null," +
  '"conditionOutput": visibleCondition.conditionOutput' +
  "} : null," +
  '"description": null ' +
  "}]" +
  "}]" +
  "}]" +
  "}";
export const response_type_map = {
  0: "txt",
  120000000: "sing",
  120000001: "mul",
  120000002: "txt",
  120000003: "mxtxt",
  120000004: "dropdown",
  120000005: "usDropdown",
  120000006: "address",
  120000007: "emoji",
  120000008: "",
};
